export default "__VITE_ASSET__Dycsrmn9__"